export default function CardLoader() {
    return(
        <div className="card-loader rounded">
            
        </div>
    )
}